import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VEHICLE_BUY_IN_RESOURCE } from "./use-vehicle-buy-in-create-data.query";

export const VEHICLE_BUY_IN_CREATE_API_PATH = "/v1/vehicle-buy-in" as const;

export type VehicleBuyInCreateBody =
  paths[typeof VEHICLE_BUY_IN_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type VehicleBuyInCreateResponse =
  paths[typeof VEHICLE_BUY_IN_CREATE_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export function useVehicleBuyInCreateMutation() {
  const queryClient = useQueryClient();

  return useMutation<VehicleBuyInCreateResponse, Error, VehicleBuyInCreateBody>({
    mutationFn: async (body) => {
      const response = await alphartisApiAxios.post<VehicleBuyInCreateResponse>(VEHICLE_BUY_IN_CREATE_API_PATH, body);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [VEHICLE_BUY_IN_RESOURCE] });
    },
  });
}
